import * as StringUtil from '@/common/StringUtil';

export default class Entry {
  constructor() {
    this.entryCode = '';
    this.rankCode = '';
    this.title = '';
    this.entryDate = '';
    this.resultDate = '';
    this.resultCode = '';
    this.thumbnail = '';
    this.alternativeText = '';
    this.status = '';
    this.canRetake = true;
    this.registrationRequired = false;
  }

  public static clone(entry: Entry): Entry {
    const cloneEntry = new Entry();
    cloneEntry.entryCode = entry.entryCode;
    cloneEntry.rankCode = entry.rankCode;
    cloneEntry.title = entry.title;
    cloneEntry.entryDate = entry.entryDate;
    cloneEntry.resultDate = entry.resultDate;
    cloneEntry.resultCode = entry.resultCode;
    cloneEntry.thumbnail = entry.thumbnail;
    cloneEntry.alternativeText = entry.alternativeText;
    cloneEntry.status = entry.status;
    cloneEntry.canRetake = entry.canRetake;
    cloneEntry.registrationRequired = entry.registrationRequired;
    return cloneEntry;
  }

  public entryCode: string;

  public rankCode: string;

  public get orgRankCode(): string {
    return StringUtil.decodeFromBase64Url(this.rankCode);
  }

  public title: string;

  public entryDate: string;

  public resultDate: string;

  public resultCode: string;

  public thumbnail: string;

  public alternativeText: string;

  public status: string;

  public canRetake: boolean;

  public registrationRequired: boolean;
}
